(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-home-clean-a"] && !Shopify.designMode) return;
  try {
    
  if (!window.framesPlusHomeCarouselsBound) {
    window.framesPlusHomeCarouselsBound = true;

    var carouselConfigs = [
      {
        carouselSelector: '[data-size-mini-carousel]',
        viewportSelector: '[data-size-mini-viewport]',
        trackSelector: '[data-size-mini-viewport]',
        cardSelector: '.cc-home-a__size-links a',
        directionSelector: '[data-size-mini-direction]',
        directionAttr: 'data-size-mini-direction',
        readyKey: 'sizeMiniReady'
      },
      {
        carouselSelector: '[data-finish-carousel]',
        viewportSelector: '[data-finish-viewport]',
        trackSelector: '[data-finish-track]',
        cardSelector: '.cc-home-a__finish-card',
        directionSelector: '[data-finish-direction]',
        directionAttr: 'data-finish-direction',
        readyKey: 'finishReady'
      }
    ];

    function updateCarousel(carousel, config) {
      var viewport = carousel.querySelector(config.viewportSelector);
      if (!viewport) return;
      var previousButton = carousel.querySelector('[' + config.directionAttr + '="-1"]');
      var nextButton = carousel.querySelector('[' + config.directionAttr + '="1"]');
      var atStart = viewport.scrollLeft <= 4;
      var atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
      if (previousButton) previousButton.disabled = atStart;
      if (nextButton) nextButton.disabled = atEnd;
    }

    function getCarouselStep(viewport, config) {
      var card = viewport.querySelector(config.cardSelector);
      if (!card) return viewport.clientWidth;
      var track = viewport.querySelector(config.trackSelector);
      var styles = track ? window.getComputedStyle(track) : null;
      var gap = styles ? parseFloat(styles.columnGap || styles.gap || 0) : 0;
      return card.getBoundingClientRect().width + gap;
    }

    function initHomeCarousels() {
      carouselConfigs.forEach(function(config) {
        document.querySelectorAll(config.carouselSelector).forEach(function(carousel) {
          if (carousel.dataset[config.readyKey] === 'true') {
            updateCarousel(carousel, config);
            return;
          }
          carousel.dataset[config.readyKey] = 'true';
          var viewport = carousel.querySelector(config.viewportSelector);
          if (!viewport) return;
          viewport.addEventListener('scroll', function() {
            updateCarousel(carousel, config);
          }, { passive: true });
          updateCarousel(carousel, config);
        });
      });
    }

    document.addEventListener('click', function(event) {
      carouselConfigs.forEach(function(config) {
        var button = event.target.closest(config.directionSelector);
        if (!button) return;
        var carousel = button.closest(config.carouselSelector);
        if (!carousel) return;
        var viewport = carousel.querySelector(config.viewportSelector);
        if (!viewport) return;
        var direction = parseInt(button.getAttribute(config.directionAttr), 10);
        viewport.scrollBy({ left: getCarouselStep(viewport, config) * direction * 2, behavior: 'smooth' });
        window.setTimeout(function() {
          updateCarousel(carousel, config);
        }, 260);
      });
    });

    window.addEventListener('resize', initHomeCarousels);
    document.addEventListener('shopify:section:load', initHomeCarousels);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHomeCarousels);
    } else {
      initHomeCarousels();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-10x10-collection"]) return;
  try {
    
function fp10InitGallery(root) {
  if (root.dataset.fp10Ready) return;
  root.dataset.fp10Ready = 'true';
  const grid = root.querySelector('.fpten-a2-grid');
  const cards = Array.from(grid.children);
  const colour = root.querySelector('select[data-fp-colour]');
  const range = root.querySelector('select[data-fp-range]');
  const sort = root.querySelector('select[data-fp-sort]');
  const pack = root.querySelector('select[data-fp-pack]');
  const frame = root.querySelector('select[data-fp-frame-size]');
  const swatches = [...root.querySelectorAll('[data-fp-swatch]')];
  const modes = [...root.querySelectorAll('[data-mode-button]')];
  const resets = [...root.querySelectorAll('.fpten-a2-reset')];
  let mode = 'unmounted';

  function populate(select, key, label) {
    const selected = select.value;
    select.replaceChildren(new Option(label, ''));
    const values = [...new Set(cards.filter(card => card.dataset.mode === mode).map(card => card.dataset[key]))];
    values.sort((a, b) => a.localeCompare(b, undefined, {numeric: true}));
    const labels = new Map(cards.filter(card => card.dataset.mode === mode).map(card => [card.dataset[key], card.dataset[key + 'Label'] || card.dataset[key]]));
    values.forEach(value => select.add(new Option(labels.get(value) || value, value)));
    select.value = values.includes(selected) ? selected : '';
  }

  function update() {
    const ordered = [...cards].sort((a, b) => {
      if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort.value === 'title') return a.querySelector('h2').textContent.localeCompare(b.querySelector('h2').textContent);
      return Number(a.dataset.order) - Number(b.dataset.order);
    });
    let count = 0;
    ordered.forEach(card => {
      card.hidden = card.dataset.mode !== mode ||
        Boolean(colour.value && card.dataset.fpColour !== colour.value) ||
        Boolean(range.value && card.dataset.fpRange !== range.value) ||
        Boolean(mode === 'unmounted' && pack.value && card.dataset.quantity !== pack.value) ||
        Boolean(mode === 'mounted' && frame.value && card.dataset.frameSize !== frame.value);
      if (!card.hidden) count++;
      grid.append(card);
    });
    root.querySelector('[data-fp-count]').textContent = String(count);
    root.querySelector('.fpten-a2-no-match').hidden = count > 0;
    resets[0].hidden = !colour.value && !range.value && !(mode === 'unmounted' ? pack.value : frame.value);
    swatches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fpSwatch === colour.value)));
    modes.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modeButton === mode)));
  }

  function selectMode(value) {
    mode = value;
    populate(colour, 'fpColour', root.dataset.allColours);
    populate(range, 'fpRange', root.dataset.allRanges);
    populate(frame, 'frameSize', root.dataset.allFrameSizes);
    root.querySelector('[data-pack-label]').hidden = mode === 'mounted';
    root.querySelector('[data-frame-label]').hidden = mode !== 'mounted';
    root.querySelector('[data-fp-type-help]').textContent = mode === 'mounted'
      ? root.dataset.helpMounted
      : root.dataset.helpDirect;
    update();
  }

  [colour, range, sort, pack, frame].forEach(select => select.addEventListener('change', update));
  swatches.forEach(button => button.addEventListener('click', () => { colour.value = button.dataset.fpSwatch; update(); }));
  modes.forEach(button => button.addEventListener('click', () => selectMode(button.dataset.modeButton)));
  resets.forEach(button => button.addEventListener('click', () => { colour.value = ''; range.value = ''; pack.value = ''; frame.value = ''; update(); }));
  root.querySelector('.fpten-a2-controls').hidden = false;
  selectMode('unmounted');
}
document.querySelectorAll('[data-fp10-collection-gallery]').forEach(fp10InitGallery);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fp10-collection-gallery]').forEach(fp10InitGallery));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-12x12-collection"]) return;
  try {
    
function fps12InitGallery(root) {
  if (root.dataset.fps12Ready) return;
  root.dataset.fps12Ready = 'true';
  const grid = root.querySelector('.fps12-a2-grid');
  const cards = Array.from(grid.children);
  const colour = root.querySelector('select[data-fps12-colour]');
  const range = root.querySelector('select[data-fps12-range]');
  const sort = root.querySelector('select[data-fps12-sort]');
  const swatches = [...root.querySelectorAll('[data-fps12-swatch]')];
  const resets = [...root.querySelectorAll('.fps12-a2-reset')];
  for (const [key, select] of [['fps12Colour', colour], ['fps12Range', range]]) {
    [...new Set(cards.map(card => card.dataset[key]))].sort().forEach(value => select.add(new Option(value, value)));
  }
  function update() {
    const ordered = [...cards].sort((a, b) => {
      if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort.value === 'title') return a.querySelector('h2').textContent.localeCompare(b.querySelector('h2').textContent);
      return Number(a.dataset.order) - Number(b.dataset.order);
    });
    let count = 0;
    ordered.forEach(card => {
      card.hidden = !!((colour.value && card.dataset.fps12Colour !== colour.value) || (range.value && card.dataset.fps12Range !== range.value));
      if (!card.hidden) count++;
      grid.append(card);
    });
    root.querySelector('[data-fps12-count]').textContent = String(count);
    root.querySelector('.fps12-a2-no-match').hidden = count > 0;
    resets[0].hidden = !colour.value && !range.value;
    swatches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fps12Swatch === colour.value)));
  }
  [colour, range, sort].forEach(select => select.addEventListener('change', update));
  swatches.forEach(button => button.addEventListener('click', () => {colour.value = button.dataset.fps12Swatch; update();}));
  resets.forEach(button => button.addEventListener('click', () => {colour.value = ''; range.value = ''; update();}));
  root.querySelector('.fps12-a2-controls').hidden = false;
  update();
}
document.querySelectorAll('[data-fps12-collection-gallery]').forEach(fps12InitGallery);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fps12-collection-gallery]').forEach(fps12InitGallery));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-14x11-collection"]) return;
  try {
    
function fp14InitGallery(root) {
  if (root.dataset.fp14Ready) return;
  root.dataset.fp14Ready = 'true';
  const grid = root.querySelector('.fp14-a2-grid');
  const cards = Array.from(grid.children);
  const colour = root.querySelector('select[data-fp14-colour]');
  const range = root.querySelector('select[data-fp14-range]');
  const sort = root.querySelector('select[data-fp14-sort]');
  const swatches = [...root.querySelectorAll('[data-fp14-swatch]')];
  const resets = [...root.querySelectorAll('.fp14-a2-reset')];
  for (const [key, select] of [['fp14Colour', colour], ['fp14Range', range]]) {
    [...new Set(cards.map(card => card.dataset[key]))].sort().forEach(value => select.add(new Option(value, value)));
  }
  function update() {
    const ordered = [...cards].sort((a, b) => {
      if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort.value === 'title') return a.querySelector('h2').textContent.localeCompare(b.querySelector('h2').textContent);
      return Number(a.dataset.order) - Number(b.dataset.order);
    });
    let count = 0;
    ordered.forEach(card => {
      card.hidden = !!((colour.value && card.dataset.fp14Colour !== colour.value) || (range.value && card.dataset.fp14Range !== range.value));
      if (!card.hidden) count++;
      grid.append(card);
    });
    root.querySelector('[data-fp14-count]').textContent = String(count);
    root.querySelector('.fp14-a2-no-match').hidden = count > 0;
    resets[0].hidden = !colour.value && !range.value;
    swatches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fp14Swatch === colour.value)));
  }
  [colour, range, sort].forEach(select => select.addEventListener('change', update));
  swatches.forEach(button => button.addEventListener('click', () => {colour.value = button.dataset.fp14Swatch; update();}));
  resets.forEach(button => button.addEventListener('click', () => {colour.value = ''; range.value = ''; update();}));
  root.querySelector('.fp14-a2-controls').hidden = false;
  update();
}
document.querySelectorAll('[data-fp14-collection-gallery]').forEach(fp14InitGallery);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fp14-collection-gallery]').forEach(fp14InitGallery));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-16x12-collection"]) return;
  try {
    
function fp16InitGallery(root) {
  if (root.dataset.fp16Ready) return;
  root.dataset.fp16Ready = 'true';
  const grid = root.querySelector('.fp16-a2-grid');
  const cards = Array.from(grid.children);
  const colour = root.querySelector('select[data-fp16-colour]');
  const range = root.querySelector('select[data-fp16-range]');
  const sort = root.querySelector('select[data-fp16-sort]');
  const swatches = [...root.querySelectorAll('[data-fp16-swatch]')];
  const resets = [...root.querySelectorAll('.fp16-a2-reset')];
  for (const [key, select] of [['fp16Colour', colour], ['fp16Range', range]]) {
    [...new Set(cards.map(card => card.dataset[key]))].sort().forEach(value => select.add(new Option(value, value)));
  }
  function update() {
    const ordered = [...cards].sort((a, b) => {
      if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort.value === 'title') return a.querySelector('h2').textContent.localeCompare(b.querySelector('h2').textContent);
      return Number(a.dataset.order) - Number(b.dataset.order);
    });
    let count = 0;
    ordered.forEach(card => {
      card.hidden = !!((colour.value && card.dataset.fp16Colour !== colour.value) || (range.value && card.dataset.fp16Range !== range.value));
      if (!card.hidden) count++;
      grid.append(card);
    });
    root.querySelector('[data-fp16-count]').textContent = String(count);
    root.querySelector('.fp16-a2-no-match').hidden = count > 0;
    resets[0].hidden = !colour.value && !range.value;
    swatches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fp16Swatch === colour.value)));
  }
  [colour, range, sort].forEach(select => select.addEventListener('change', update));
  swatches.forEach(button => button.addEventListener('click', () => {colour.value = button.dataset.fp16Swatch; update();}));
  resets.forEach(button => button.addEventListener('click', () => {colour.value = ''; range.value = ''; update();}));
  root.querySelector('.fp16-a2-controls').hidden = false;
  update();
}
document.querySelectorAll('[data-fp16-collection-gallery]').forEach(fp16InitGallery);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fp16-collection-gallery]').forEach(fp16InitGallery));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-6x6-collection"]) return;
  try {
    
function fps6InitGallery(root) {
  if (root.dataset.fps6Ready) return;
  root.dataset.fps6Ready = 'true';
  const grid = root.querySelector('.fps6-a2-grid');
  const cards = Array.from(grid.children);
  const colour = root.querySelector('select[data-fps6-colour]');
  const range = root.querySelector('select[data-fps6-range]');
  const sort = root.querySelector('select[data-fps6-sort]');
  const swatches = [...root.querySelectorAll('[data-fps6-swatch]')];
  const resets = [...root.querySelectorAll('.fps6-a2-reset')];
  for (const [key, select] of [['fps6Colour', colour], ['fps6Range', range]]) {
    [...new Set(cards.map(card => card.dataset[key]))].sort().forEach(value => select.add(new Option(value, value)));
  }
  function update() {
    const ordered = [...cards].sort((a, b) => {
      if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort.value === 'title') return a.querySelector('h2').textContent.localeCompare(b.querySelector('h2').textContent);
      return Number(a.dataset.order) - Number(b.dataset.order);
    });
    let count = 0;
    ordered.forEach(card => {
      card.hidden = !!((colour.value && card.dataset.fps6Colour !== colour.value) || (range.value && card.dataset.fps6Range !== range.value));
      if (!card.hidden) count++;
      grid.append(card);
    });
    root.querySelector('[data-fps6-count]').textContent = String(count);
    root.querySelector('.fps6-a2-no-match').hidden = count > 0;
    resets[0].hidden = !colour.value && !range.value;
    swatches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fps6Swatch === colour.value)));
  }
  [colour, range, sort].forEach(select => select.addEventListener('change', update));
  swatches.forEach(button => button.addEventListener('click', () => {colour.value = button.dataset.fps6Swatch; update();}));
  resets.forEach(button => button.addEventListener('click', () => {colour.value = ''; range.value = ''; update();}));
  root.querySelector('.fps6-a2-controls').hidden = false;
  update();
}
document.querySelectorAll('[data-fps6-collection-gallery]').forEach(fps6InitGallery);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fps6-collection-gallery]').forEach(fps6InitGallery));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-a2-collection"]) return;
  try {
    
function fpInitA2(root){
 if(root.dataset.fpReady)return;root.dataset.fpReady='true';
 const cards=[...root.querySelectorAll('.fp-a2-card')],colour=root.querySelector('select[data-fp-colour]'),range=root.querySelector('select[data-fp-range]'),swatches=[...root.querySelectorAll('[data-fp-swatch]')],resets=[...root.querySelectorAll('.fp-a2-reset')];
 for(const [field,select] of [['fpColour',colour],['fpRange',range]]){[...new Set(cards.map(c=>c.dataset[field]))].sort().forEach(v=>select.add(new Option(v,v)));}
 const update=()=>{let count=0;cards.forEach(c=>{const show=(!colour.value||c.dataset.fpColour===colour.value)&&(!range.value||c.dataset.fpRange===range.value);c.hidden=!show;if(show)count++;});root.querySelector('[data-fp-count]').textContent=count;root.querySelector('.fp-a2-no-match').hidden=count>0;swatches.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.fpSwatch===colour.value)));resets[0].hidden=!colour.value&&!range.value;};
 colour.addEventListener('change',update);range.addEventListener('change',update);
 swatches.forEach(b=>b.addEventListener('click',()=>{colour.value=b.dataset.fpSwatch;update();}));
 resets.forEach(b=>b.addEventListener('click',()=>{colour.value='';range.value='';update();}));
 root.querySelector('.fp-a2-controls').hidden=false;update();
}
document.querySelectorAll('[data-fp-a2]').forEach(fpInitA2);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-fp-a2]').forEach(fpInitA2));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-related"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    root.querySelectorAll('[data-fp-related]').forEach(section => {
      if (section.dataset.ready || section.dataset.carousel !== 'true') return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.fp-related-track');
      const cards = Array.from(track.children);
      const previous = section.querySelector('[data-prev]');
      const next = section.querySelector('[data-next]');
      const nav = section.querySelector('.fp-related-nav');
      const footer = section.querySelector('.fp-related-footer');
      const count = section.querySelector('.fp-related-count');
      const bar = section.querySelector('.fp-related-progress span');
      if (!cards.length) return;
      const gap = () => parseFloat(getComputedStyle(track).gap) || 0;
      const step = () => cards[0].getBoundingClientRect().width + gap();
      function update() {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        nav.hidden = footer.hidden = max < 5;
        previous.disabled = track.scrollLeft < 5;
        next.disabled = track.scrollLeft >= max - 5;
        const size = step();
        if (size <= 0) return;
        const first = Math.min(cards.length, Math.round(track.scrollLeft / size) + 1);
        const visible = Math.max(1, Math.floor((track.clientWidth + gap() + 1) / size));
        count.textContent = (visible === 1 ? first : first + '–' + Math.min(cards.length, first + visible - 1)) + ' ' + section.dataset.of + ' ' + cards.length;
        const ratio = Math.min(1, track.clientWidth / track.scrollWidth);
        bar.style.width = 100 * ratio + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? track.scrollLeft / max * (1 - ratio) / ratio * 100 : 0) + '%)';
      }
      function move(direction) {
        track.scrollBy({left: direction * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'ArrowLeft') move(-1);
        else if (event.key === 'ArrowRight') move(1);
        else track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'auto'});
      });
      let pending = false;
      track.addEventListener('scroll', () => { if (!pending) { pending = true; requestAnimationFrame(() => { update(); pending = false; }); } }, {passive: true});
      const observer = new ResizeObserver(update);
      observer.observe(track);
      section.addEventListener('fp-related-cleanup', () => observer.disconnect(), {once: true});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-fp-related]').forEach(section => section.dispatchEvent(new Event('fp-related-cleanup'))));
})();

  } catch(e) { console.error(e); }
})();
})();
